import React from 'react';

/** @import { Notification } from './Notifications/NotificationTypes' */
/** @import { Profile, ProfileAccount } from '../../contexts/CustomerDataProviderTypes' */
/** @import { Certificate, Statement } from '../MyDocuments/MyDocumentsTypes' */

/** @type {ProfileAccount} */
export const toAccount = { name: 'HSBC', accountNumber: '23423445', sortCode: '12-34-56' };

/** @type {Profile} */
export const profile = {
  name: 'Johnny',
  middleName: 'Mark',
  surname: 'Smith',
  mobileNumber: '+44777412342',
  email: 'johnny@example.com',
  address: {
    flatNumber: '14',
    building: '2 Thames House',
    street: 'South Road',
    town: 'London',
    country: 'England',
    postal: 'W2 1JB',
    postalCode: ''
  },
  marketingPreference: {
    email: true,
    phone: false,
    onlineBankingMessaging: false
  },
  linkedAccount: toAccount,
  interestPaidTo: 'flex_saver_account'
};

export const accounts = [{
  id: 1,
  accountNumber: '724562456',
  sortCode: '12-34-56',
  product: {
    interestRate: 1.4,
    name: 'Flexi Saver',
  },
  blendedRate: [
    'Balances < £5, 000 interest is 0 %',
    'Balances > £5, 000 interest is 1, 4 %',
    'Balances > £1m interest is 2 %'
  ],
  balance: 90085,
  activity: [{
    id: 1,
    action: 'Withdraw',
    date: new Date(2019, 9, 8),
    amount: -500,
    balance: 90085,
    metadata: [
      { label: 'Transaction Number', value: '123412341' },
      { label: 'Account number', value: '12-34-56' }
    ]
  }, {
    id: 2,
    action: 'Withdraw',
    date: new Date(2019, 8, 25),
    amount: -100,
    balance: 90085,
    metadata: [
      { label: 'Transaction Number', value: '123412341' },
      { label: 'Account number', value: '12-34-56' }
    ]
  }, {
    id: 3,
    action: 'Interest Earned',
    date: new Date(2019, 8, 25),
    amount: 1238,
    balance: 90085,
    metadata: [
      { label: 'Interest Rate', value: '1.2%' }
    ],
    interestPeriod: [new Date(2019, 7, 25), new Date(2019, 8, 5)]
  }, {
    id: 4,
    action: 'Interest Earned',
    date: new Date(2019, 8, 24),
    amount: 1234,
    balance: 90085,
    metadata: [
      { label: 'Interest Rate', value: '1.2%' }
    ],
    interestPeriod: [new Date(2019, 7, 25), new Date(2019, 8, 5)]
  }, {
    id: 5,
    action: 'Deposit',
    date: new Date(2019, 8, 24),
    amount: 1238,
    balance: 90085
  }, {
    id: 6,
    action: 'Withdraw',
    date: new Date(2019, 6, 12),
    amount: -500,
    balance: 90085,
    metadata: [
      { label: 'Transaction Number', value: '123412341' },
      { label: 'Account number', value: '12-34-56' }
    ]
  }]
}, {
  id: 2,
  accountNumber: '12341234343',
  sortCode: '12-34-56',
  product: {
    interestRate: 1.4,
    name: 'Fixed Deposit',
  },
  blendedRate: [
    'Balances < £5, 000 interest is 0 %',
    'Balances > £5, 000 interest is 1, 4 %',
    'Balances > £1m interest is 2 %'
  ],
  balance: 123105,
  activity: []
}, {
  id: 3,
  product: {
    name: 'Notice Plus',
    interestRate: 1.4,
  },
  accountNumber: '345534634',
  sortCode: '12-34-56',
  blendedRate: [
    'Balances < £5, 000 interest is 0 %',
    'Balances > £5, 000 interest is 1, 4 %',
    'Balances > £1m interest is 2 %'
  ],
  balance: 4709,
  activity: []
}];

const getUserId = () => localStorage.getItem("iuid");

/** @type {Notification[]} */
export const notifications = [
  {
    id: 'notification-1-welcome',
    date: new Date(),
    title: 'Welcome to your online dashboard!',
    read: () => !!localStorage.getItem(`${getUserId()}-read-notification-1-welcome`),
    dismissed: () => !!localStorage.getItem(`${getUserId()}-dismissed-notification-1-welcome`),
    dismiss: () => localStorage.setItem(`${getUserId()}-dismissed-notification-1-welcome`, "true"),
    markAsRead: () => localStorage.setItem(`${getUserId()}-read-notification-1-welcome`, "true"),
    body: {
        title: 'Your Investec Save account is open and ready to use.',
        paragraphs: [
            'Using your account online is simple and easy to do! From here you can view your account activity, keep your personal details up to date and so much more.',
            (<br/>),
            (<>Top tip: Save this <a href="/" target="_blank">link</a> to your browser favourites for quick access going forward.</>)
        ]
    }
  }
];

/** @type {Statement[]} */
export const statements = [
  {
    id: 1,
    date: new Date(2019, 8, 25),
    name: 'Online Flexi Saver Statement',
    accountNumber: '76473664',
    downloadLink: '#'
  },
  {
    id: 2,
    date: new Date(2019, 8, 25),
    name: 'Online Flexi Saver Statement',
    accountNumber: '76473664',
    downloadLink: '#'
  },
  {
    id: 3,
    date: new Date(2019, 8, 25),
    name: 'Online Flexi Saver Statement',
    accountNumber: '76473664',
    downloadLink: '#'
  }
];

/** @type {Certificate[]} */
export const certificates = [
  {
    id: 4,
    date: new Date(2019, 8, 25),
    name: 'Online Flexi Saver Interest Certificate',
    accountNumber: '76473664',
    downloadLink: '#'
  },
  {
    id: 5,
    date: new Date(2019, 8, 25),
    name: 'Online Flexi Saver Interest Certificate',
    accountNumber: '76473664',
    downloadLink: '#'
  },
  {
    id: 6,
    date: new Date(2019, 8, 25),
    name: 'Online Flexi Saver Interest Certificate',
    accountNumber: '76473664',
    downloadLink: '#'
  }
];
